import { Instance } from 'mobx-state-tree';
import getFormattedDistance from '../../../helpers/getFormattedDistance';
import { RoutesStatsDetailDtoModelBase } from './RoutesStatsDetailDtoModel.base';
import { DistanceUnit } from './DistanceUnitEnum';

/* The TypeScript type of an instance of RoutesStatsDetailDtoModel */
export interface RoutesStatsDetailDtoModelType extends Instance<typeof RoutesStatsDetailDtoModel.Type> {}

/* A graphql query fragment builders for RoutesStatsDetailDtoModel */
export { selectFromRoutesStatsDetailDto, routesStatsDetailDtoModelPrimitives, RoutesStatsDetailDtoModelSelector } from './RoutesStatsDetailDtoModel.base';

/**
 * RoutesStatsDetailDtoModel
 *
 * Aggregate Routes Details
 */
export const RoutesStatsDetailDtoModel = RoutesStatsDetailDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views((self) => ({
    get workingTimeMinutes(): number | undefined {
      return self.workingTime !== undefined ? Math.floor(self.workingTime / 60) : undefined;
    },
  }))
  .views((self) => ({
    get kmsFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.KM, 2);
    },
    get shortKmsFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.KM);
    },
    get milesFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.MILES, 2);
    },
    get shortMilesFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.MILES);
    },
  }));
